import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { UiStore } from 'stores';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

// Utils
import analyticsUtil from '../util/AnalyticsUtil';
import { pageNames } from '../data/page-names';

export class BookmarkletController implements Controller {
  public pageId = pageNames.bookmarklet;
  public path = '/:localeName/bookmarklet';
  public routeName = 'bookmarklet';
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "bookmarklet-page" */ '../views/bookmarklet-page'));
  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, request } = options;
    const analyticsStore: AnalyticsStore = stores?.get<AnalyticsStore>('analytics');

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, request.context);

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Bookmarklet' }) as Promise<PageData>;
  }
}
